import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, date }) =>
    present(
      repository
        .validatePersonalTimeRecords(resource, date)
        .then(() => ({ resource, date }))
        .catch(() => Promise.reject({ resource, date })),
    );
}

export type { Interactor };

export { createInteractor };
